import 'inputmask/lib/extensions/inputmask.numeric.extensions';
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import { ValidationProvider } from 'vee-validate';
import VShowSlide from 'v-show-slide';
import ReflectAttrs from '@ssi/vue-common/src/components/helpers/ReflectAttrs';
import focus from '@ssi/vue-common/src/directives/focus';
import uniqName from '@ssi/vue-common/src/mixins/uniqName';
import pendingOps from '@ssi/vue-common/src/store/modules/pendingOps';
import ContentCard from '@/components/ContentCard';
import { formatJsonDate } from '@/helpers/dateHelpers';
import InputMask from '@/plugins/mask';
import NotFound from '@/views/NotFound';
import './validationSetup';

// eslint-disable-next-line import/no-dynamic-require
const config = require(process.env.VUE_APP_CONFIG_PATH).default;

Vue.config.productionTip = false;

Vue.component('ContentCard', ContentCard);
Vue.component('ReflectAttrs', ReflectAttrs);
Vue.component('ValidationProvider', ValidationProvider);

Vue.directive('focus', focus);

Vue.filter('formatCurrency', val => `$${Number(val).toFixed(2)}`);
Vue.filter('formatJsonDate', formatJsonDate);

Vue.mixin(uniqName);

Vue.use(InputMask);
Vue.use(VShowSlide);
Vue.use(Vuex);
Vue.use(VueRouter);

/**
 * Initializes the application with the given root component.
 * @param {Vue Component} rootComponent The root Vue App component.
 * @param {Array} routes Routes for vue-router.
 * @param {Object} opts Other root component initialization options.
 */
export default function init(rootComponent, routes, opts) {
  new Vue({
    provide: { config },
    render: h => h(rootComponent),
    router: new VueRouter({
      base: process.env.VUE_APP_BASE_URI,
      mode: 'history',
      routes: [
        ...routes,
        { path: '*', component: NotFound }
      ]
    }),
    store: new Vuex.Store({ modules: { pendingOps } }),
    ...opts
  }).$mount('#app-container');
}
